import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InternalTitle } from 'BaseDataTypes';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InternalTitleService {
  constructor(private http: HttpClient) {}
  /**
   * Gets all the internaltitles from the database
   * @returns
   */
  getInternalTitles(): Observable<InternalTitle[]> {
    return this.http.get<InternalTitle[]>('/api/InternalTitles');
  }
  /**
   * Deletes an internaltitle by providing its ID
   * @param id
   * @returns
   */
  deleteInternalTitle(id: number): Observable<InternalTitle> {
    return this.http.delete<InternalTitle>('/api/InternalTitles/' + id);
  }
  /**
   * Updates an internaltitle object by providing the new internaltitle object
   * @param internalTitle
   * @returns
   */
  updateInternalTitle(internalTitle: InternalTitle): Observable<InternalTitle> {
    return this.http.put<InternalTitle>(
      '/api/InternalTitles/updateInternalTitle',
      internalTitle
    );
  }
}
